import { create } from 'zustand';

/**
 * The live meeting a member is currently viewing. Surfaced in a store (rather than passed via
 * props) so the persistent top nav — which is mounted in the members layout, above and outside the
 * meeting page — can render a "you are in a live meeting" treatment. `null` whenever the member is
 * not inside a live meeting, so every other public area renders the nav normally.
 */
type LiveMeeting = { id: number; title: string; isRecessed: boolean };

interface LiveMeetingNavProperties {
  liveMeeting: LiveMeeting | null;
}

interface LiveMeetingNavState extends LiveMeetingNavProperties {
  setLiveMeeting: (liveMeeting: LiveMeeting) => void;
  clearLiveMeeting: () => void;
}

const initialProperties: LiveMeetingNavProperties = {
  liveMeeting: null,
};

export const useLiveMeetingNavStore = create<LiveMeetingNavState>((set) => ({
  ...initialProperties,
  setLiveMeeting: (liveMeeting) => set({ liveMeeting }),
  clearLiveMeeting: () => set({ liveMeeting: null }),
}));
